import { FleetOverview } from "interfaces/fleet-overview";
import { Column } from "react-table";

export const getFleetTableColumns = (
  hasFeature: (feature: string) => boolean
): Column<FleetOverview>[] => {
  const baseColumns: Column<FleetOverview>[] = [
    {
      Header: "Site",
      id: "site",
      accessor: data => data.site
    },
    {
      Header: "No. of Machines",
      id: "no_turbines",
      accessor: data => data.no_turbines
    },
    {
      Header: "Cases Open",
      id: "cases_open",
      accessor: data => data.cases_open
    },
    {
      Header: "Down/Derated",
      id: "down_derated",
      accessor: data => data.down_derated
    }
  ];

  if (hasFeature("alerts")) {
    // Insert the "Alerts" column as the fourth column
    baseColumns.splice(3, 0, {
      Header: "Alerts",
      id: "alerts",
      accessor: data => data.alerts
    });
  }

  return baseColumns;
};
